import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import httpClient from '../../api/httpClient';

export type TCountriesData = {
  data: string[];
};

export type TBanksItemData = {
  bankId: number;
  name: string;
}

export type TBanksData = {
  data: TBanksItemData[];
};

export const getCountries = createAsyncThunk<TCountriesData>(
  'countries/get',
  async () => {
    try {
      const response = await httpClient.get('/api/v1/bank-connections/countries')
        .then(response => {
          return response.data;
        });
      return await response;
    } catch (e) {
      return console.log('countries/fetch error' + e);
    }
  }
);

export const getBanks = createAsyncThunk<TBanksData, { countryCode: string }>(
  'banks/get',
  async ({ countryCode }) => {
    try {
      const response = await httpClient.get(`/api/v1/bank-connections/countries/${countryCode}/banks`)
        .then(response => {
          return response.data;
        });
      return await response;
    } catch (e) {
      return console.log('banks/fetch error' + e);
    }
  }
);

interface CountriesState {
  countries: TCountriesData['data'] | null;
  banks: TBanksData['data'] | null;
  loading: boolean;
  banksLoading: boolean;
  error: boolean;
}

const initialState: CountriesState = {
  countries: null,
  banks: null,
  banksLoading: true,
  loading: true,
  error: false,
};

export const countriesSlice = createSlice({
  name: 'countries',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCountries.pending, (state) => {
      state.countries = null;
    });
    builder.addCase(getCountries.fulfilled, (state, action) => {
      state.countries = action.payload.data;
      state.loading = false;
      state.error = false;
    });
    builder.addCase(getCountries.rejected, (state) => {
      state.loading = false;
      state.error = true;
    });
    builder.addCase(getBanks.pending, (state) => {
      state.banks = null;
      state.banksLoading = true;
    });
    builder.addCase(getBanks.fulfilled, (state, action) => {
      state.banks = action.payload.data;
      state.banksLoading = false;
      state.error = false;
    });
    builder.addCase(getBanks.rejected, (state) => {
      state.banksLoading = false;
      state.error = true;
    });
  },
});

export default countriesSlice.reducer;